import { Box } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useEffect } from "react";
import { useNatGateway } from "../../../hooks/useNatGateway";
import NatGatewayCard from "./NatGatewayCard";

/**
 * Component for managing NAT gateways in the admin interface.
 * 
 * @component
 * @example
 * return (
 *   <NatGateways />
 * )
 * 
 * @returns {JSX.Element} Grid containing NAT gateway cards for different services
 */
function NatGateways() {
  // Use the NAT gateway hooks
  const {
    isReady: nigelReady,
    createGateway: createNigel,
    checkStatus: checkNigelStatus,
    deleteGateway: deleteNigel,
  } = useNatGateway("nigel-natgw");

  const {
    isReady: scraperReady,
    createGateway: createScraper,
    deleteGateway: deleteScraper,
    checkStatus: checkScraperStatus,
  } = useNatGateway("scraper-natgw");

  // Check status on component mount
  useEffect(() => {
    checkNigelStatus();
    checkScraperStatus();
  }, [checkNigelStatus, checkScraperStatus]);

  return (
    <Box sx={{ pb: 5, width: "100%" }}>
      <Grid container width="100%" height="100%" spacing={1}>
        {/* Nigel NAT Gateway */}
        <NatGatewayCard
          name="nigel-natgw"
          isReady={nigelReady}
          disabled={true} // Always disabled
          onDelete={deleteNigel}
          onCreate={createNigel}
        />

        {/* Scraper NAT Gateway */}
        <NatGatewayCard
          name="scraper-natgw"
          isReady={scraperReady}
          disabled={false}
          onDelete={deleteScraper}
          onCreate={createScraper}
        />
      </Grid>
    </Box>
  );
}

export default NatGateways;
